import { memo } from 'react';

import { cn } from '@/lib/utils';

/**
 * InitialLoading component optimized for low-resource PCs
 * Minimal rendering with no animations for best performance
 */
export const InitialLoading = memo(() => {
  return (
    <div
      className={cn(
        'fixed inset-0 z-[9999] flex items-center justify-center',
        'bg-white dark:bg-slate-900',
      )}
    >
      {/* Main loading container */}
      <div className="flex flex-col items-center space-y-8">
        {/* Logo container */}
        <div className="relative">
          {/* Logo background */}
          <div
            className={cn(
              'flex h-20 w-20 items-center justify-center rounded-xl',
              'bg-blue-600 dark:bg-blue-500',
              'shadow-sm',
            )}
          >
            {/* App logo */}
            <img
              src="/images/logo.jpg"
              alt="Healthy Empire"
              className="h-10 w-auto object-contain"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                const parent = target.parentElement;
                if (parent) {
                  parent.innerHTML = `
                    <svg class="h-8 w-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                    </svg>
                  `;
                }
              }}
            />
          </div>
        </div>

        {/* App title */}
        <div className="space-y-2 text-center">
          <h1
            className={cn(
              'text-2xl font-bold',
              'text-slate-900 dark:text-white',
            )}
          >
            Healthy Zone
          </h1>
          <p
            className={cn(
              'text-sm font-medium',
              'text-slate-600 dark:text-slate-300',
            )}
          >
            النظام الذكي لإدارة شركات الدواء
          </p>
        </div>

        {/* Simple loading indicator */}
        <div className="h-8 w-8">
          <div
            className={cn(
              'h-full w-full rounded-full border-4 border-slate-200',
              'border-t-blue-600 dark:border-slate-700 dark:border-t-blue-400',
            )}
          />
        </div>

        {/* Loading text */}
        <div className="space-y-1 text-center">
          <h2
            className={cn(
              'text-lg font-semibold',
              'text-slate-800 dark:text-slate-100',
            )}
          >
            جاري تحميل النظام...
          </h2>
          <p
            className={cn(
              'text-sm font-medium',
              'text-slate-500 dark:text-slate-400',
            )}
          >
            يرجى الانتظار
          </p>
        </div>
      </div>
    </div>
  );
});

InitialLoading.displayName = 'InitialLoading';
